import { render, staticRenderFns } from "./FormAddRestrictions.vue?vue&type=template&id=a8b942c4&scoped=true"
import script from "./FormAddRestrictions.vue?vue&type=script&lang=js"
export * from "./FormAddRestrictions.vue?vue&type=script&lang=js"
import style0 from "./FormAddRestrictions.vue?vue&type=style&index=0&id=a8b942c4&prod&lang=scss&scoped=true"
import style1 from "./FormAddRestrictions.vue?vue&type=style&index=1&id=a8b942c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b942c4",
  null
  
)

export default component.exports